import { render, staticRenderFns } from "./DeActiveMember.vue?vue&type=template&id=5b7e5041"
import script from "./DeActiveMember.vue?vue&type=script&lang=js"
export * from "./DeActiveMember.vue?vue&type=script&lang=js"
import style0 from "./DeActiveMember.vue?vue&type=style&index=0&id=5b7e5041&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports